export class CustomerSelectItem {
  Id: number;
  Name: string;
}

export class JobsiteSelectItem {
  Id: number;
  Name: string;
}
export class EquipmentSelectItem {
  Id: number;
  SerialNumber: string;
  UnitNumber: string;
  ModelId:number;
  select:boolean=false;
  SMU:number;

}
export class Equipment {
  Id: number;
  CustomerId: number;
  JobsiteId: number;
  SerialNumber: string;
  UnitNumber: string;
  MakeId: number;
  ModelId: number;
  Smu: number;
  Ltd: number;
  Date: Date;
  Photo: string;
  HoursOfUsePerDay: number;
  UsedMonday: boolean;
  UsedTuesday: boolean;
  UsedWednesday: boolean;
  UsedThursday: boolean;
  UsedFriday: boolean;
  UsedSaturday: boolean;
  UsedSunday: boolean;
  InspectEvery: number;
  InspectEveryUnitTypeId: number;
  ApplicationId: number;
  RankingId: number;
  StatusId: number;
  CreatedByUserId: number;
  CanChangeSmuLtd: number;
  Bcm:number;
  Ton:number;
  EnableAutoInspectionPlanner: boolean = false;
  SetupDate:string;
  ForecastId:number;
}

export class Tuple {
  public m_Item1: any;
  public m_Item2: any;
}

export class SerializedTuple {
  public Item1: any;
  public Item2: any;
}
export class CustomerSelectItemVM {
  public SelectedCustomerList: CustomerSelectItem[]
}

export class EquipmentDetailsParams{
  public PercentWorn: number = 0;
  public CustomerName: string;
  public JobsiteName: string;
  public SerialNumber: string;
  public UnitNumber: string;
  public LastInspectionDate: string;
  public NextInspectionDate: string;
  public Smu: number;
  public Ltd: number;
  public Make: string;
  public Model: string;
  public Family: string;
  public EquipmentPhoto: string;
  public CustomerId: number;
  public JobsiteId: number;
  public NextSmu : number;
  public InspectEvery: number;
  public InspectEveryUnitTypeId: number;
  public EquipmentSetupDate : string;
  public Bcm:number;
  public Ton :number;
  public equipmentId:number;
  public InventoryStatus: number;
  public IsPendingAssetActions: boolean;
}
export class MakeSetupVM{
  public  makeId:number
  public  makeSymbol:string
  public  makeName :string
  public  createdDate:Date
  public  CreateduserID:number
  public  createdUser:string
  public  modifiedDate :Date
  public  modifiedUserID :number
  public  modifiedUser :string
  public  isUndercarriage: boolean
  public  isComponent: boolean
  public  isOEM: boolean
}

